<script>
	export let columnWidth = 'medium';
</script>

<div class="grid" id={columnWidth}>
	<slot />
</div>

<style>
	.grid {
		display: grid;
		margin-right: 2.5rem;
		gap: 4.5em;
		margin-top: 1.8rem;
		margin-bottom: 1.8rem;
	}
	#small {
		grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
	}

	#medium {
		grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	}

	#large {
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	}

	#xlarge {
		grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
	}

	@media (max-width: 1800px) {
		.grid {
			margin-right: 8rem;
		}
	}

	@media(max-width: 1600px){
		#medium {
			grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
		}

		.grid{
			gap: 1.5em;
			margin-right: 0rem;
		}
	}
	@media (max-width: 1200px) {
		.grid {
			margin-right: 1.5rem;
		}
	}

	@media (max-width: 768px) {
		.grid {
			gap: 1.5em;
			margin-right: 0.5rem;
		}

		#medium {
			grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
		}
	}
</style>
